import { Component } from "react"
import PropTypes from "prop-types"
import { chain, map, pick } from "lodash"
import pluralize from "pluralize"
import { Paper } from "@mui/material"
import ToolbarHeader from "components/securities-table/toolbar-header"
import { MAX_SECURITIES_DOWNLOAD } from "helpers/securities-search"
import Table from "components/securities-table/table"
import { intFormatter } from "helpers/formatters/numbers"
import { DATE } from "helpers/shapes"
import MetricsSelector from "components/metrics-selector"
import { AvailableColumnShape } from "components/metrics-selector/helpers/prop-types"
import "./styles.scss"

class SecuritiesFinderResults extends Component {
  static propTypes = {
    foundSecurities: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number.isRequired,
    setPage: PropTypes.func.isRequired,
    columns: PropTypes.array,
    selectedColumns: PropTypes.objectOf(PropTypes.bool).isRequired,
    setSelectedColumns: PropTypes.func.isRequired,
    columnSelectorOpen: PropTypes.bool.isRequired,
    toggleColumnSelector: PropTypes.func.isRequired,
    setSort: PropTypes.func.isRequired,
    selectedSort: PropTypes.object,
    filterId: PropTypes.string,
    status: PropTypes.string,
    selectAllSecurities: PropTypes.func,
    openSecurityProfile: PropTypes.func,
    openFactorProfile: PropTypes.func,
    openCompositeSecurity: PropTypes.func,
    selectSecurity: PropTypes.func,
    selectedSecurities: PropTypes.object,
    toolbarActive: PropTypes.bool,
    currentPageSelectionStatus: PropTypes.string,
    watchlistsMenuVisible: PropTypes.bool,
    toggleWatchlistsMenu: PropTypes.func,
    modelId: PropTypes.string.isRequired,
    preferredSelectedColumns: PropTypes.objectOf(PropTypes.bool),
    download: PropTypes.func,
    filter: PropTypes.object,
    sort: PropTypes.object,
    account: PropTypes.string.isRequired,
    selectedDate: DATE.isRequired,
    errorMessage: PropTypes.string,
    addNotification: PropTypes.func.isRequired,
    isOpPro: PropTypes.bool.isRequired,
    currency: PropTypes.string,
    isHistoricalFactorSensitivityAvailable: PropTypes.bool,
    availableColumns: PropTypes.arrayOf(AvailableColumnShape).isRequired,
  }

  componentDidUpdate(prevProps) {
    const { errorMessage, addNotification } = this.props
    if (errorMessage && prevProps.errorMessage !== errorMessage) {
      addNotification("error", null, errorMessage)
    }
  }

  onDownload = () => {
    const { account, modelId, filter, columns: columnsByCategory, sort, selectedDate, download, currency, isHistoricalFactorSensitivityAvailable } = this.props

    const apiSort = sort.getter(sort.id, sort.direction)
    const selectedColumns = chain(columnsByCategory)
      .map(category => map(category.columns, column => ({
        ...pick(column, ["id", "type", "label"]),
        skipQuery: column.type === "historicalFactorSensitivity" && !isHistoricalFactorSensitivityAvailable,
      })))
      .flatten()
      .value()

    download(account, modelId, filter, apiSort, selectedColumns, selectedDate, currency)
  }

  render() {
    const {
      account,
      filterId,
      status,
      foundSecurities,
      count,
      page,
      setPage,
      selectAllSecurities,
      columns,
      selectedColumns,
      setSelectedColumns,
      columnSelectorOpen,
      toggleColumnSelector,
      selectSecurity,
      setSort,
      selectedSecurities,
      toolbarActive,
      openSecurityProfile,
      openFactorProfile,
      openCompositeSecurity,
      currentPageSelectionStatus,
      watchlistsMenuVisible,
      toggleWatchlistsMenu,
      selectedDate,
      isOpPro,
      modelId,
      availableColumns,
    } = this.props

    if (!filterId) {
      // No search happened yet
      return null
    }

    return <Paper className="modules_securities-finder-results">
      <MetricsSelector
        isOpen={columnSelectorOpen}
        toggle={toggleColumnSelector}
        setSelectedMetrics={(metrics) => setSelectedColumns(metrics, modelId)}
        selectedMetrics={selectedColumns}
        availableMetrics={availableColumns}
      />
      <ToolbarHeader
        heapCreateWatchlistId="screener-create-watchlist"
        heapAddToWatchlistId="screener-apply-to-watchlist"
        title={`Found ${intFormatter(count)} ${pluralize("security", count)}`}
        active={toolbarActive}
        selectedDate={selectedDate}
        onColumnSelectorToggle={toggleColumnSelector}
        selectedSecurities={selectedSecurities.securities}
        selectedSecuritiesTotal={selectedSecurities.total}
        watchlistsMenuVisible={watchlistsMenuVisible}
        toggleWatchlistsMenu={toggleWatchlistsMenu}
        download={this.onDownload}
        count={count}
        modelId={modelId}
        maxSecuritiesDownload={isOpPro ? MAX_SECURITIES_DOWNLOAD.pro : MAX_SECURITIES_DOWNLOAD.enterprise}
      />
      <Table
        id="securities-finder-table"
        columns={columns}
        currentPageSelectionStatus={currentPageSelectionStatus}
        selectAllSecurities={selectAllSecurities}
        count={count}
        setPage={setPage}
        status={status}
        page={page}
        selectedSecurities={selectedSecurities.securities}
        selectSecurity={selectSecurity}
        setSort={setSort}
        openSecurityProfile={openSecurityProfile}
        openCompositeSecurity={(security) => openCompositeSecurity(account, security, false, modelId)}
        openFactorProfile={openFactorProfile}
        foundSecurities={foundSecurities}
        noSortLabels
      />
    </Paper>
  }
}

export default SecuritiesFinderResults
